import { css } from '@emotion/react';

const dataContextStyles = css`
    .placeholder-wrapper {
        margin-bottom: 16px;
        background-color: #f9f9f9;
        border: 1px solid #eee;
        border-radius: 4px;
        padding: 24px;
    }

    .data-context {
        .data-context-title {
            font-weight: bold;
        }
`;

export default dataContextStyles;
